(() => {
  const headingText = document.currentScript.dataset.heading;
  const update = (container) => {
    for (const widget of container.querySelectorAll('.minicart__entries lb-upsell-widget[widget="widget#icuc"]')) {
      const entries = widget.closest('.minicart__entries');
      if (entries.firstElementChild !== widget) entries.prepend(widget);
      const heading = widget.querySelector('.lb-addon-title');
      if (heading && heading.textContent !== headingText) heading.textContent = headingText;
    }
  };
  for (const container of document.querySelectorAll('[data-cart-settings="product-list"]')) {
    new MutationObserver(() => update(container)).observe(container, { childList: true, subtree: true, characterData: true });
    update(container);
  }
})();
